import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { APP_DEFAULT_PATH } from 'config';
// import useAuth from 'hooks/useAuth';
// import usePermission from 'hooks/usePermission';
// import { PERMISSION_LIST } from 'config';
import { useSelector } from 'store';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  // const { hasAuditModulePermision, allPolicyPermission } = usePermission();
  // const hasPolicyViewPermission = allPolicyPermission[PERMISSION_LIST.VIEW_CATALOG];

  useEffect(() => {
    if (isLoggedIn) {
      let defaultPath = APP_DEFAULT_PATH;
      // if(!hasAuditModulePermision && hasPolicyViewPermission){
      //   defaultPath = '/policy_catalog'
      // }
      // if(hasAuditModulePermision && !hasPolicyViewPermission){
      //   defaultPath = '/audit/workboard'
      // }
      navigate(location?.state?.from ? location?.state?.from : defaultPath, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
